import React, { useEffect, useState } from 'react'
import { Layout } from 'antd'
import Menu from 'components/Menu'
import Footer from 'components/Footer'
import Cookie from 'components/Cookie'
import Cookies from 'js-cookie'

const { Content } = Layout

export const isAcceptCookie = () => {
  const acceptCookie = Cookies.get('accept_cookie')
  return Boolean(acceptCookie)
}

export const setAcceptCookie = () => {
  return Cookies.set('accept_cookie', true)
}

const PublicLayout = ({ children }) => {
  const [checkCookie, setCheckCookie] = useState(isAcceptCookie())

  return (
    <Layout style={{ background: '#fff' }}>
      {!checkCookie && (
        <Cookie setAcceptCookie={setAcceptCookie} setCheckCookie={setCheckCookie} checkCookie={checkCookie} />
      )}
      <div id="google_translate_element" />
      <Menu />
      <Content>
        <div>{children}</div>
      </Content>
      <Footer />
    </Layout>
  )
}

export default PublicLayout
